export const MODIFY_TIER = 'MODIFY_TIER';

export function modifyTier(tier){
    return{
        type: MODIFY_TIER,
        mainState: {
            tier: tier
        }
    }
}